module.exports = __webpack_public_path__ + "img/newsImg6-4.f1d547df.png";